<template>
    <div class="product-image-modal">
        <div class="product-image-modal-wrapper">
            <div class="product-image-modal-inner">
                <slick
                    :options="{
                        arrows: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        nextArrow: `<button class='slick-next'>&raquo;</button>`,
                        prevArrow: `<button class='slick-prev'>&laquo;</button>`,
                    }"
                    class="product-image-modal-slider"
                >
                    <image-modal-item
                        v-for="(image, index) in images"
                        :key="index"
                        :item="image"
                    />
                </slick>

                <button
                    @click="$store.commit('global/toggleImageModal')"
                    class="product-image-modal-close"
                    aria-label="Close modal"
                >
                    &times;
                </button>
            </div>

            <p class="text-center hidden-until-md">
                {{ $t('product.zoom') }}
            </p>
        </div>
        <button
            @click="$store.commit('global/toggleImageModal')"
            class="product-image-modal-background"
            aria-label="Close modal"
        />
    </div>
</template>

<script>
    import ImageModalItem from '@/_vue/components/product/image-modal-item';

    export default {
        name: 'ProductImageModal',
        components: {
            ImageModalItem,
        },
        props: {
            images: {
                type: Array,
                default: () => [],
            },
        },
    };
</script>
